import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
  InputNumber,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import styles from "../../../../assets/styles/styles";
import { labelConfig, staticConfig } from "../../systemAdmin.config";

const BranchLimitForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    // isLoading,
    // setIsLoading,
    configureLimitTableSource,
    setConfigurelimitTableSource,
    paymentTypeOptions,
    assetAccountOptions,
    LimitCount,
    setLimitCount,
    currencyData,
  } = props;

  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBranchLimitDelete = (key) => {
    console.log(key);

    let action = "Delete  ";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Please Confirm Action",
      "",
      "Yes",
      "No",

      function () {
        const newData = configureLimitTableSource.filter(
          (item) => item.id !== key.id,
        );
        setConfigurelimitTableSource(newData);
      },

      function () {
        // No button
      },
    );
  };

  const columns = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Authorization Threshold",
      dataIndex: "authThresholdAmount",
    },
    {
      title: "Daily Transaction Limit",
      dataIndex: "transactionLimit",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureLimitTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleBranchLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Branch Limit Information
        </Title>
      </Divider>
      <BranchLimitModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        paymentTypeOptions={paymentTypeOptions}
        assetAccountOptions={assetAccountOptions}
        setConfigurelimitTableSource={setConfigurelimitTableSource}
        configureLimitTableSource={configureLimitTableSource}
        LimitCount={LimitCount}
        setLimitCount={setLimitCount}
        currencyData={currencyData}
      />

      {configureLimitTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {configureLimitTableSource.length > 1
                ? "Added Branch Limits"
                : "Added Branch Limit"}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={configureLimitTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};
export default BranchLimitForm;

const BranchLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigurelimitTableSource,
    configureLimitTableSource,
    isModalOpen,
    setIsModalOpen,
    LimitCount,
    setLimitCount,
    currencyData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleBranchLimitSave = (formValues) => {
    // console.log(formValues);

    const newAuthLimit = {
      key: LimitCount,
      id: LimitCount,
      authThresholdAmount: formValues.authThresholdAmount.toLocaleString(),
      currencyCode: formValues.currencyCode,
      transactionLimit: formValues.transactionLimit.toLocaleString(),
    };
    setLimitCount(LimitCount + 1);

    let foundLimits = configureLimitTableSource.find(
      (item) => item.currencyCode === newAuthLimit?.currencyCode,
    );
    if (foundLimits) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Limit allowed!");
      return;
    }
    setConfigurelimitTableSource([...configureLimitTableSource, newAuthLimit]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Limit Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchLimitSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select",
                  )}
                  options={currencyData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="authThresholdAmount"
                label={labelConfig.authThreshold}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.authThreshold),
                  },
                ]}
              >
                <InputNumber
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.authThreshold,
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionLimit"
                label={labelConfig.transactionLimit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionLimit),
                  },
                ]}
              >
                <InputNumber
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transactionLimit,
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
